import { getAccountId } from "../utilities/localStorage";

export const isPPAccessColFeatureAvailable = () => {
  return [1300, 9374, 16997, 16998, 20709, 23421, 13462].includes(
    Number(getAccountId()),
  );
};

export const isAutoLogoutFeatureAvailable = () => {
  return ![5665].includes(Number(getAccountId()));
};

export const isNewShopifyFeatureAvailable = () => {
  return [16998].includes(Number(getAccountId()));
};
